import { Container, Text, VStack, HStack, Button, Icon } from '@chakra-ui/react';
import { Home, ArrowLeft } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const NotFoundView = () => {
  const onGoBack = () => {
    window.history.back();
  };

  return (
    <Container maxW="lg" py={20}>
      <VStack gap={8} textAlign="center">
        {/* 404 Number */}
        <Text
          fontSize="8xl"
          fontWeight="bold"
          color="bg.muted"
          lineHeight="none"
          letterSpacing="tight"
        >
          404
        </Text>

        <VStack gap={2}>
          <Text fontSize="2xl" fontWeight="medium">
            Sidan kunde inte hittas
          </Text>
          <Text fontSize="md" color="fg.muted" maxW="md">
            Den sida du letar efter finns inte eller har flyttats till en annan adress.
          </Text>
        </VStack>

        {/* Action Buttons */}
        <HStack gap={3} pt={4}>
          <Button variant="outline" onClick={onGoBack} size="md">
            <Icon mr={2} boxSize={4}>
              <ArrowLeft />
            </Icon>
            Gå tillbaka
          </Button>
          <NavLink to="/" style={{ textDecoration: 'none' }}>
            <Button colorScheme="blue" size="md">
              <Icon mr={2} boxSize={4}>
                <Home />
              </Icon>
              Hem
            </Button>
          </NavLink>
        </HStack>

        {/* Help Text */}
        <Text fontSize="sm" color="fg.muted" pt={8}>
          Om problemet kvarstår, kontakta oss på{' '}
          <Text
            as="span"
            color={{
              base: 'black',
              _dark: 'white',
            }}
            fontWeight="medium"
          >
            info@palatium.se
          </Text>
        </Text>
      </VStack>
    </Container>
  );
};

export default NotFoundView;
